<aw-wizard #simpleFunctionWizard >

    <!-- Step 1: Select Object Type-->
    <aw-wizard-step [stepTitle]="'Select Object Type'" [canExit]="mObjectType != null">
      <div class="panel-body">
				<div class="form-group">
          <div class="row">
            <div class="col-sm-2">
              <label>Object Type:</label>
            </div>
						<div class="col-sm-5">
                <select class="form-control" [(ngModel)]="mObjectType" [ngModelOptions]="{standalone: true}" (change)="onSelectedObjectTypeChanged()">
                    <option [ngValue]="null" selected="selected">-- Choose -- </option>
                    <option *ngFor="let type of mAvailableObjectTypes" [ngValue]="type">
                      {{type}}
                    </option>
                </select>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
          <button type="button" class="btn btn-primary disabled" disabled><i class="fa fa-arrow-left" aria-hidden="true"></i> BACK</button>
          <button type="button" class="btn btn-primary" awNextStep>NEXT <i class="fa fa-arrow-right" aria-hidden="true"></i></button>
      </div>
    </aw-wizard-step>


    <!-- Step 2: Select Instance -->
    <aw-wizard-step [stepTitle]="mObjectType == null? 'Select Instance' : ('Select ' + mObjectType)" [canEnter]="mObjectType != null">
      <div class="panel-body">
				<div class="form-group">
          <div class="row">
            <div class="col-sm-2">
              <label>{{mObjectType}}:</label>
            </div>
						<div class="col-sm-5">
                <select class="form-control" [(ngModel)]="mInstance" [ngModelOptions]="{standalone: true}" (change)="onSelectedInstanceChanged()">
                    <option [ngValue]="null" selected="selected">-- Choose -- </option>
                    <option *ngFor="let instance of mAvailableInstances" [ngValue]="instance">
                      {{instance.name}}
                    </option>
                </select>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
          <button type="button" class="btn btn-primary" awPreviousStep><i class="fa fa-arrow-left" aria-hidden="true"></i> BACK</button>
          <button type="button" class="btn btn-primary" awNextStep>NEXT <i class="fa fa-arrow-right" aria-hidden="true"></i></button>
      </div>
    </aw-wizard-step>

    
    <!-- Step 3: Select Function -->
    <aw-wizard-step [stepTitle]="'Select Function'" [canEnter]="mInstance != null">
      <div class="panel-body">
          <div class="form-group">
            <div class="row">
              <div class="col-sm-2">
                <label>Function:</label>
              </div>
              <div class="col-sm-5">
                  <select class="form-control" [(ngModel)]="mFunction" [ngModelOptions]="{standalone: true}" (change)="onSelectedFunctionChanged()">
                      <option [ngValue]="null" selected="selected">-- Choose -- </option>
                      <option *ngFor="let function of mAvailableFunctions" [ngValue]="function">
                        {{function.name}}
                      </option>
                  </select>
              </div>
            </div>
          </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-primary" awPreviousStep><i class="fa fa-arrow-left" aria-hidden="true"></i> BACK</button>
        <button type="button" class="btn btn-primary" awNextStep>NEXT <i class="fa fa-arrow-right" aria-hidden="true"></i></button>
      </div>
    </aw-wizard-step>


    <!-- Step 4: Specify Parameters -->
    <aw-wizard-step [stepTitle]="'Specify Parameters'" [canEnter]="mFunction != null">
        <div class="panel-body">
          <ng-container *ngIf="mFunction != null">
            <!-- If/Else div controlling which template to use (No Parameters or Contains Parameters) -->
            <div *ngIf="mFunction.parameters == null || mFunction.parameters.length == 0;then no_parameters else contains_parameters"></div>

            <!-- Template that gets displayed if Function contains no parameters -->
            <ng-template #no_parameters>
                <h4><i>Function contains no parameters.</i></h4>
            </ng-template>
  
            <!-- Template that gets displayed if Function contains parameters -->
            <ng-template #contains_parameters>
              <ng-container *ngFor="let parameter of mParameterValues">
                <div class="row">
                  <div class="col-sm-2">
                    <div class="row">
                      <div class="col-sm-9">
                        <label>{{parameter.mParameter.name}}:</label>
                      </div>
                      <div class="col-sm-3">
                          <button type="button" class="btn btn-primary btn-sm" *ngIf="parameter.mParameter.multiValue" (click)="addValueToParameterData(null, parameter)">+</button>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-10">
                    <ng-container *ngFor="let parameterValue of parameter.mParameterValues">
                      <div class="row" [ngSwitch]="parameter.mParameter.type">
                        
                        <div class="col-sm-11">

                          <!-- BOOLEAN -->
                          <ng-container *ngSwitchCase="propertyType.BOOLEAN">
                            <app-function-parameter-editor-boolean [parameterValue]="parameterValue" (valueChange)="onParameterDataChange(parameter, parameterValue)"></app-function-parameter-editor-boolean>
                          </ng-container>

                          <!-- DOUBLE / FLOAT / INTEGER / LONG / SHORT -->
                          <ng-container *ngSwitchCase="propertyType.DOUBLE">
                            <app-function-parameter-editor-number [parameterValue]="parameterValue" (valueChange)="onParameterDataChange(parameter, parameterValue)"></app-function-parameter-editor-number>
                          </ng-container>
                          <ng-container *ngSwitchCase="propertyType.FLOAT">
                            <app-function-parameter-editor-number [parameterValue]="parameterValue" (valueChange)="onParameterDataChange(parameter, parameterValue)"></app-function-parameter-editor-number>
                          </ng-container>
                          <ng-container *ngSwitchCase="propertyType.INTEGER">
                            <app-function-parameter-editor-number [parameterValue]="parameterValue" (valueChange)="onParameterDataChange(parameter, parameterValue)"></app-function-parameter-editor-number>
                          </ng-container>
                          <ng-container *ngSwitchCase="propertyType.LONG">
                            <app-function-parameter-editor-number [parameterValue]="parameterValue" (valueChange)="onParameterDataChange(parameter, parameterValue)"></app-function-parameter-editor-number>
                          </ng-container>
                          <ng-container *ngSwitchCase="propertyType.SHORT">
                            <app-function-parameter-editor-number [parameterValue]="parameterValue" (valueChange)="onParameterDataChange(parameter, parameterValue)"></app-function-parameter-editor-number>
                          </ng-container>

                          <!-- STRING -->
                          <ng-container *ngSwitchCase="propertyType.STRING">
                            <app-function-parameter-editor-string [event]="mEvent" [parameterValue]="parameterValue" (valueChange)="onParameterDataChange(parameter, parameterValue)"></app-function-parameter-editor-string>
                          </ng-container>





                          <!-- ANTENNA_REFERENCE -->
                          <ng-container *ngSwitchCase="propertyType.ANTENNA_REFERENCE">
                            <app-function-parameter-editor-antenna [event]="mEvent" [parameterValue]="parameterValue" (valueChange)="onParameterDataChange(parameter, parameterValue)"></app-function-parameter-editor-antenna>
                          </ng-container>

                          <!-- DRIVEROBJECT_REFERENCE -->
                          <ng-container *ngSwitchCase="propertyType.DRIVEROBJECT_REFERENCE">
                            <app-function-parameter-editor-driver-object [event]="mEvent" [parameterValue]="parameterValue" (valueChange)="onParameterDataChange(parameter, parameterValue)"></app-function-parameter-editor-driver-object>
                          </ng-container>

                          <!-- EVENTINST_REFERENCE -->
                          <ng-container *ngSwitchCase="propertyType.EVENTINST_REFERENCE">
                            <app-function-parameter-editor-event [event]="mEvent" [parameterValue]="parameterValue" (valueChange)="onParameterDataChange(parameter, parameterValue)"></app-function-parameter-editor-event>
                          </ng-container>

                          <!-- LOCATION_REFERENCE -->
                          <ng-container *ngSwitchCase="propertyType.LOCATION_REFERENCE">
                            <app-function-parameter-editor-location [event]="mEvent" [parameterValue]="parameterValue" (valueChange)="onParameterDataChange(parameter, parameterValue)"></app-function-parameter-editor-location>
                          </ng-container>

                          <!-- OBJECT_REFERENCE -->
                          <ng-container *ngSwitchCase="propertyType.OBJECT_REFERENCE">
                            <app-function-parameter-editor-object [event]="mEvent" [parameterValue]="parameterValue" (valueChange)="onParameterDataChange(parameter, parameterValue)"></app-function-parameter-editor-object>
                          </ng-container>

                          <!-- READER_REFERENCE -->
                          <ng-container *ngSwitchCase="propertyType.READER_REFERENCE">
                            <app-function-parameter-editor-reader [event]="mEvent" [parameterValue]="parameterValue" (valueChange)="onParameterDataChange(parameter, parameterValue)"></app-function-parameter-editor-reader>
                          </ng-container>

                          <!-- TAG_REFERENCE -->
                          <ng-container *ngSwitchCase="propertyType.TAG_REFERENCE">
                              <app-function-parameter-editor-tag [event]="mEvent" [parameterValue]="parameterValue" (valueChange)="onParameterDataChange(parameter, parameterValue)"></app-function-parameter-editor-tag>
                            </ng-container>

                          <!-- USER REFERENCE -->
                          <ng-container *ngSwitchCase="propertyType.USER_REFERENCE">
                            <app-function-parameter-editor-user [event]="mEvent" [parameterValue]="parameterValue" (valueChange)="onParameterDataChange(parameter, parameterValue)"></app-function-parameter-editor-user>
                          </ng-container>

                          <!-- ZONE REFERENCE -->
                          <ng-container *ngSwitchCase="propertyType.ZONE_REFERENCE">
                            <app-function-parameter-editor-zone [event]="mEvent" [parameterValue]="parameterValue" (valueChange)="onParameterDataChange(parameter, parameterValue)"></app-function-parameter-editor-zone>
                          </ng-container>

                          <!-- DEFAULT (Not a known type, handling needs to be added)-->
                          <ng-container *ngSwitchDefault>
                            <span class="form-control">[UNKNOWN ELEMENT TYPE: {{parameter.mParameter.type}}]</span>
                          </ng-container>
                        </div>
                        
                        <div class="col-sm-1">
                          <button type="button" class="btn btn-primary btn-sm" *ngIf="parameter.mParameter.multiValue" (click)="removeValueFromParameterData(parameterValue, parameter)">-</button>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-container>

            </ng-template>
          </ng-container>
        </div>
  
        <div class="modal-footer">
            <button type="button" class="btn btn-primary" awPreviousStep><i class="fa fa-arrow-left" aria-hidden="true"></i> BACK</button>
            <button type="button" class="btn btn-primary disabled" disabled>NEXT <i class="fa fa-arrow-right" aria-hidden="true"></i></button>
        </div>
    </aw-wizard-step>

</aw-wizard>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>